








































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import PageNames from '@/router/PageNames';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import ContactWorkerDto from '@/models/ContactWorkers/ContactWorkerDto';

@Component({
  name: 'WorkerContactsList',
  components: {  }
})
export default class extends GiganautVue {

    blockingDialog = false;
    editIsBlocking = true;
    editContactWorkerId = '';

    async beforeMount() {
       await WorkerDetailsModule.getContacts();
    }

    async navigateToContact(contactId: string) {
        this.$router.push({ name: PageNames.AgencyContactDetails, params: { contactid: contactId } });
    }

    openBlockingDialog(item: ContactWorkerDto) {
        this.editContactWorkerId = item.id;
        this.editIsBlocking = item.isBlocking;
        this.blockingDialog = true;
    }

    async saveBlocking() {
        await WorkerDetailsModule.updateContactWorkerIsBlocking({
            id: this.editContactWorkerId,
            isBlocking: this.editIsBlocking,
        });
        this.blockingDialog = false;
    }

    get loading() {
        return WorkerDetailsModule.loadingContacts;
    }

    get contacts() {
        return WorkerDetailsModule.contacts;
    }

    private headers = [
        { text: 'Name' },
        { text: 'Owner' },
        { text: 'Blocking' },
        { text: 'Sent At'  },
    ]
}
